import { CONTENT_ITEMS, USER_CONTENT_ITEMS } from '../graphql/queries/contentItem';
import { useFetchItems } from './useFetchItems';
export const useContentItems = ({ clientId, code, parentId, locale }) => {
    const { items, error, loading } = useFetchItems({
        fetchQuery: CONTENT_ITEMS,
        dataProp: 'contentItems',
        skip: !clientId || (!parentId && !code),
        spec: {
            clientId,
            parentId,
            code,
            locale,
        },
    });
    return {
        items,
        error,
        loading,
    };
};
export const useUserContentItems = ({ code, locale, clientId }) => {
    const { items, error, loading } = useFetchItems({
        fetchQuery: USER_CONTENT_ITEMS,
        dataProp: 'userContentItems',
        skip: !code,
        spec: {
            code,
            locale,
            clientId,
        },
    });
    return {
        items,
        error,
        loading,
    };
};
